import React from "react";

import "./../../Styles/LoadingSpinner.css";

const LoadingSpinner = ({ color }) => {
    return (
        <svg
            className="LoadingSpinner_wrapper"
            width="50px"
            height="50px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                className="LoadingSpinner_circle-path"
                fill="transparent"
                strokeWidth="3"
                cx="33"
                cy="33"
                r="30"
                stroke={color}
            ></circle>
            <svg
                className="spinner-dot dot"
                width="5px"
                height="5px"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
                x="37"
                y="1.5"
            ></svg>
        </svg>
    );
};

LoadingSpinner.defaultProps = {
    color: "#fff",
};

export default LoadingSpinner;
